import React from 'react';
import './SpinnerLoaderBlack.css'
const SpinnerLoaderBlack = () => {
  return (
     <div className="custom-loader-spinner-black"></div>
  );
};

export default SpinnerLoaderBlack;